// 서비스
export default [
  {
    path: '/:locale([en]*)?/service',
    name: 'Service',
    component: () => import('@/views/service/Index'),
    meta: {
      scroll: true,
      sitemap: {
        loc: '/service'
      }
    },
    redirect: {
      name: 'service-order'
    },
    children: [
      {
        name: 'service-order',
        path: 'order',
        component: () => import('@/views/service/Order'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Service',
          sitemap: {
            loc: '/service/order'
          }
        },
      },
      {
        name: 'service-commerce',
        path: 'commerce',
        component: () => import('@/views/service/Commerce'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Service',
          sitemap: {
            loc: '/service/commerce'
          }
        },
      },
      {
        name: 'service-ceo',
        path: 'ceo',
        component: () => import('@/views/service/Ceo'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Service',
          sitemap: {
            loc: '/service/ceo'
          }
        },
      },
      {
        name: 'service-culture',
        path: 'culture',
        component: () => import('@/views/service/Culture'),
        meta: {
          // scroll: true,
          // language: false,
          parent: 'Service',
          sitemap: {
            loc: '/service/culture'
          }
        },
      }
    ]
  }
]
